import withWaitingComponent from 'Common/HOC/withWaitingComponent';
import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router';
import config from 'config';
import { useLocalStorageState } from 'ahooks';
import { AccountPersistInfo } from 'Internal.CommonAPI';
import ErrorBoundary from 'Common/pages/error';
import AccountScreen from './screens/Account';
import ReadersScreen from './screens/Readers';
import SettingsScreen from './screens/Settings';

const { IN_PRODUCTION } = config;

const ReportsScreen = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ShorePayReports" */
      './screens/Reports'
    )
);

const ShorePayRouter = () => {
  const [account] = useLocalStorageState<AccountPersistInfo>('account');
  const location = useLocation();

  if (location.pathname === '/shorepay') {
    return <Navigate to="/shorepay/account" />;
  }

  return (
    <Routes>
      <Route path="account" element={withWaitingComponent(AccountScreen)} />
      <Route
        path="readers"
        element={!IN_PRODUCTION ? <ReadersScreen /> : <ErrorBoundary />}
      />
      <Route path="reports" element={withWaitingComponent(ReportsScreen)} />
      {account !== undefined && (
        <Route
          path="settings"
          element={
            account.isShorePayUser ? (
              withWaitingComponent(SettingsScreen)
            ) : (
              <ErrorBoundary />
            )
          }
        />
      )}
      <Route path="*" element={<ErrorBoundary />} />
    </Routes>
  );
};

export default ShorePayRouter;
